import { ALL, RADICAL } from './constants.js';

export function capitalize(str) {
  if (!str) return '';
  return str[0].toUpperCase() + str.substr(1);
}

export function titleCase(str) {
  return str
    .split(' ')
    .map(capitalize)
    .join(' ');
}

export function pluralTitle(str) {
  if (str === RADICAL || str === capitalize(RADICAL)) return `${str}s`;
  if (str === ALL || str === capitalize(ALL)) return `subjects`;
  return str;
}

export function getCookieValue(key) {
  const keyVal = document.cookie
    .split(';')
    .filter(item => item.trim().startsWith(`${key}=`));
  if (keyVal.length === 1) {
    return keyVal[0].split('=')[1];
  }
  return null;
}

export function reverseImmutable(arr) {
  const returnArr = [];
  arr.forEach(item => returnArr.unshift(item));
  return returnArr;
}

export const isLargeScreen = () =>
  window.matchMedia('(min-width: 769px)').matches;

export function extractLevelsText(levels) {
  const levelGroups = [];
  let groupStartIndex = 0;
  for (let i = 0; i < levels.length; i++) {
    const nextItem = levels[i + 1];
    const nextNumberIsSequential = levels[i] + 1 === nextItem;
    const previousNumberIsSequential = levels[i - 1] === levels[i] - 1;
    if (!nextNumberIsSequential) {
      if (!previousNumberIsSequential) {
        levelGroups.push(levels[groupStartIndex]);
      } else {
        levelGroups.push(`${levels[groupStartIndex]}-${levels[i]}`);
      }
      groupStartIndex = i + 1;
    }
  }
  let text = levelGroups.join(', ');
  const lastLevelGroup = levelGroups[levelGroups.length - 1];
  if (text.lastIndexOf(',') !== -1) {
    return text.substr(0, text.lastIndexOf(',')) + ` and ${lastLevelGroup}`;
  }
  return text;
}
